import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'

const withStyle = (Badge) =>
  styled(Badge)((props) => {
    const { color, backgroundColor } = getColor(props.type, props.theme)
    return `
        text-transform: uppercase;
        display: inline-flex;
        padding: 0 8px;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0.2px;
        text-align: center;
        height: 16px;
        border-radius: 9px;
        overflow-y: hidden;

        color: ${color};

        background-color: ${backgroundColor};
      `
  })

export default withStyle

const getColor = (type, theme) => {
  const backgroundTypes = {
    default: theme.badgeDefaultColor,
    alert: theme.badgeWarningColor,
    true: theme.badgeTrueBackground,
    false: theme.badgeFalseBackground,
    selected: theme.selectedPrimaryColor,
    warning: themeColor('errorPrimary', { theme }),
  }
  const fontColorTypes = {
    default: theme.badgeDefaultTextColor,
    alert: theme.badgeWarningTextColor,
    true: theme.badgeDefaultTextColor,
    false: theme.badgeDefaultTextColor,
    selected: theme.badgeDefaultTextColor,
    warning: themeColor('whitePrimary', { theme }),
  }

  return {
    backgroundColor: backgroundTypes[type],
    color: fontColorTypes[type],
  }
}
